import React from 'react';
import Section from './Section';
import Heading from './Heading';

import fireblocksLogo from '../Assets/CompanyLogos/FireBlocksLogo.png';
import talosLogo from '../Assets/CompanyLogos/talos-logo.png';
import falconxLogo from '../Assets/CompanyLogos/falconx-seeklogo.png';

const Companies = () => {
  const partners = [
    { name: "Fireblocks", logo: fireblocksLogo },
    { name: "Talos", logo: talosLogo },
    { name: "FalconX", logo: falconxLogo },
  ];

  return (
    <Section id="partners">
      <div className="container">
        <div className="text-center">
          <Heading tag="Trusted Partners" title="Companies We Work With" />
        </div>

        {/* Flex row on mobile, grid on larger screens */}
        <div className="mt-10">
          <div className="flex flex-row justify-center items-center gap-8 sm:grid sm:grid-cols-3 sm:gap-8">
            {partners.map((partner, index) => (
              <div key={index} className="flex flex-col items-center">
                <div className="w-24 h-16 mb-2 flex items-center justify-center grayscale hover:grayscale-0 transition-all duration-300">
                  <img
                    src={partner.logo}
                    alt={`${partner.name} logo`}
                    className="max-h-full max-w-full object-contain"
                    loading="lazy"
                  />
                </div>
                <p className="text-sm text-white/80 dark:text-white text-center">
                  {partner.name}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Companies;


